module.exports = __webpack_public_path__ + "static/nat-west-3e47a21eea96bbc94aa4d653932d4571.png";